var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.archives.length)?_c('div',{staticClass:"session-archives"},_vm._l((_vm.archives),function(archive){return _c('VideoArchiveLink',{key:archive.id,attrs:{"archive":archive},on:{"reload":_vm.reloadArchives}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }